import React from "react";

const CryptoNetworkLogo = ({ network, className = "" }) => {
  const isTron = network === "usdt_trc20";

  return (
    <span
      className={`${className} ${isTron ? "tron" : "bnb"}`.trim()}
      aria-hidden="true"
    >
      {isTron ? (
        <svg viewBox="0 0 48 48" focusable="false">
          <path
            d="M9.5 9.2 38.9 14l-14.8 25L9.5 9.2Zm3.8 3.2 10.1 22.2 3.1-15.8-13.2-6.4Zm2.5-.2 12 5.8 7.2-2.5-19.2-3.3Zm12.9 8.4-3 13.3 9.6-16.1-6.6 2.8Z"
            fill="currentColor"
          />
        </svg>
      ) : (
        <svg viewBox="0 0 48 48" focusable="false">
          <path
            d="m24 7 7.1 7.1-4.2 4.2-2.9-2.9-2.9 2.9-4.2-4.2L24 7Zm-12 12 4.2 4.2L12 27.4 7.8 23.2 12 19Zm24 0 4.2 4.2-4.2 4.2-4.2-4.2L36 19ZM24 31l2.9-2.9 4.2 4.2L24 39.4l-7.1-7.1 4.2-4.2L24 31Zm0-11.5 3.7 3.7-3.7 3.7-3.7-3.7 3.7-3.7Z"
            fill="currentColor"
          />
        </svg>
      )}
    </span>
  );
};

export default CryptoNetworkLogo;
